import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {
  StyledFixedDetailsPanel,
  StyledFixedDetailsPanelPanelContainer,
} from './StyledFixedDetailsPanel';
import {elementHelpers, transactionsHelpers} from '../../../../utils/helpers';


const FixedDetailsPanel = ({
  children,
  hiddenOverflow = false,
  open,
  tableElementId,
  ...rest
}) => {
  const [isFixedDetailsWindow, setIsFixedDetailsWindow] = useState(false);
  const [detailsWindowFixedHeight, setDetailsWindowFixedHeight] = useState(0);

  useEffect(() => {
    let offsetTop = elementHelpers.getElementOffsetTop(`#${tableElementId}`, 4) - 24;
    if (offsetTop !== detailsWindowFixedHeight) setDetailsWindowFixedHeight(offsetTop);
  }, [isFixedDetailsWindow, tableElementId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    transactionsHelpers.addFixedDetailsWindowScrollEventListener({
      detailsWindowFixedHeight, open, isFixedDetailsWindow, setIsFixedDetailsWindow
    });
  }, [open, isFixedDetailsWindow, detailsWindowFixedHeight]);

  return (
    <StyledFixedDetailsPanel {...rest}>
      <StyledFixedDetailsPanelPanelContainer
        hiddenOverflow={hiddenOverflow}
        fixed={isFixedDetailsWindow}
      >
        {children}
      </StyledFixedDetailsPanelPanelContainer>
    </StyledFixedDetailsPanel>
  );
}

FixedDetailsPanel.propTypes = {
  hiddenOverflow: PropTypes.bool,
  fixed: PropTypes.bool,
  tableElementId: PropTypes.string,
}

export default FixedDetailsPanel;
